$(document).on('click touchend', '.lazy-load a', function(event){
    if (dragging) return;
    event.preventDefault();

    $lazyButton = $(this);

    $('body').addClass('loading');

    $contentID = '#' + $lazyButton.parent().parent().attr('id');

    $.ajax({
        url: $lazyButton.attr('href'),
        type: 'GET',
        success: function(data){
            $($contentID).append($(data).find($contentID).html());
            $lazyButton.parent().hide();
        },
        complete: function(data){
            $('body').removeClass('loading');
        }
    });
});